export enum StoreKeys {
	app = 'app',
}
